/** Destination hierarchy levels shared by Destinations collection and publish logs. */
export const DESTINATION_LEVELS = {
  continent: "Continent",
  country: "Country",
  administrative_division: "Administrative Division",
  city: "City",
  neighborhood: "Neighborhood",
} as const;

export type DestinationLevel = keyof typeof DESTINATION_LEVELS;
